<template>
  <ServicePageLayout
    title="Network"
    subtitle="ข้อมูลเครือข่าย"
    icon="mdi-network-outline"
    breadcrumb="Assets"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Network</v-tab>
      <v-tab>Connector</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><DataTableNetwork /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><DataTableConnector /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import DataTableNetwork from '@/components/network/network_table'
import DataTableConnector from '@/components/network/connector_table'

export default {
  name: 'NetworkView',
  components: {
    ServicePageLayout,
    DataTableNetwork,
    DataTableConnector
  },
  data() {
    return { tab: null }
  },
}
</script>
